import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-facturacion-edit',
  templateUrl: './facturacion-edit.component.html',
  styleUrls: ['./facturacion-edit.component.scss']
})
export class FacturacionEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
